'use client';
import styled, { css } from 'styled-components';

export const QuizHeaderWrapper = styled.div`
  display: contents;

  nav {
    position: relative;

    ${props =>
      props.$centerLogo &&
      css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-left: ${props.$withBreadcrumb && '54px'}; /*account for arrow*/
      `}
  }
`;

export const BreadcrumbContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  width: auto;
  min-width: 84px;
  position: relative;
  z-index: 1;
  padding-right: ${props => props.theme.spacing(4)};

  @media ${props => props.theme.tablet} {
    width: ${props => (props.$progress ? '20vw' : 'auto')};
    max-width: none;
  }
`;

export const CurrentProgress = styled.h3`
  ${props => props.theme.typography.bodyBold}
  color: ${props => props.theme.colors.text.lightest};
  margin-bottom: ${props => props.theme.spacing(1.5)};
  text-align: right;
  text-transform: uppercase;
`;
